import React, { useEffect, useState } from 'react';
import styles from '../products.module.scss';
import cx from 'classname';
import Input from 'components/input';
import SuccessModal from 'components/SuccessModal';
import SuccessGif from 'assets/animations/gifs/success.gif';
import { globalStyles } from 'styles';
import PhonePreview from '../Preview';
import { PreviewImageDefault } from 'components/icons';
import ToolTip from 'components/Tooltip';
import Radio from 'components/Form/Radio';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { ErrorIcon } from 'assets/svgs';
import { useHistory } from 'react-router';
import CreateProductLoading from 'components/loading/create-product';
import Button from 'components/button';
import { cloneDeep } from 'lodash';

const StepConfigureForm = (props) => {
  const { data, handleChange, setData, createCollection, money } = props;
  const pro = useSelector((state) => state.products);
  const history = useHistory();

  const findLookup = data?.collectionFields?.findIndex(function (post) {
    if (post?.lookupRequired == true) return true;
  });

  const { handleSubmit, errors, register } = useForm({
    defaultValues: {},
  });

  const [showModal, setShowModal] = useState(false);
  const [regCallback, setRegCallback] = useState(false);

  const onSubmit = () => {
    if (data?.onboardingFields.length !== 0 && !data?.registrationCallbackUrl) {
      setRegCallback(true);
    } else {
      const newData = cloneDeep(data);

      const filterMoney = newData?.collectionFields?.filter(
        (item) => item.type === 'MONEY',
      );
      if (filterMoney.length === 0) {
        newData.collectionFields.push(money);
      }

      newData.collectionFields.forEach((e) => {
        delete e.value;
        delete e.id;
      });
      newData.onboardingFields.forEach((e) => {
        delete e.value;
        delete e.id;
      });
      createCollection(newData);
    }
  };

  useEffect(() => {
    if (regCallback && data?.registrationCallbackUrl) {
      setRegCallback(false);
    }
  }, [regCallback, data?.registrationCallbackUrl]);

  const onCloseModal = () => {
    history.push('/products');
    pro.products.errors.status = false;
  };

  const onViewProduct = () => {
    history.push('/products');
    pro.products.errors.status = false;
  };

  useEffect(() => {
    if (pro?.products?.errors?.status === true) {
      setShowModal(true);
    }
  }, [pro, showModal]);

  const handleSuccessModal = () => {
    return showModal ? (
      <SuccessModal
        positiveBtn={onViewProduct}
        negativeBtn={onCloseModal}
        // closeIcon={<CloseModal />}
        decorationIcon={<img src={SuccessGif} width="150" height="150" />}
        title="Product Successfully Created"
        subtitle="We are going through your product, we will approve shortly. "
        buttonText="View Product"
      />
    ) : (
      <></>
    );
  };

  return (
    <div className={styles.chooseBody}>
      {pro?.products?.inProgress && <CreateProductLoading />}

      <div className={styles.magCreate}>
        <p className={styles.configureTitle}>Configure form</p>
        <div className={styles.createMsgs}>
          <p className={styles.configuresubtitle}>
            For validation and notifications, add your links.
          </p>
          <div className={styles.btns}>
            {/* <Button text="Skip this step" className={styles.skipBtn} /> */}
            {/* <Button
              text="Save as Draft"
              variant="gray"
              className={styles.draftsBtn}
            /> */}

            <Button
              className={styles.createBtn2}
              onClick={handleSubmit(onSubmit)}
              text="Save and submit"
              variant="primary"
            />
          </div>
        </div>

        <hr className={styles.decorline} />

        <div className={styles.rowCreate}>
          <div
            className={cx(
              styles.columnCreate,
              styles.leftCreate,
              styles.leftBg,
              styles.scrollStep,
            )}
          >
            {findLookup !== -1 && (
              <div className={styles.rowCreate}>
                <div className={cx(styles.columnCreate, styles.inputRight)}>
                  <Input
                    label="Lookup URL"
                    type="text"
                    placeholder="Enter URL here"
                    autoFocus
                    name="lookupUrl"
                    value={data?.lookupUrl}
                    onChange={handleChange}
                    ref={register({
                      required: 'Lookup URL is required',
                    })}
                    error={errors['lookupUrl']?.message}
                    data-testid="lookup input"
                  />
                </div>
                <div
                  className={cx(
                    styles.columnCreate,
                    styles.inputRight,
                    styles.createRow,
                  )}
                >
                  <ToolTip
                    id="create-product-lookup"
                    content="For a given request, the Lookup URL allows us to check if a customer exists on your system before proceeding to payment. "
                  />
                  <p className={styles.callbackUrlInfo}>What is a lookup URL</p>
                </div>
              </div>
            )}

            <div className={styles.rowCreate}>
              <div className={cx(styles.columnCreate)}>
                <p
                  className={styles.callbackUrlTitle}
                  style={{
                    marginBottom: '10px',
                  }}
                >
                  Turn on token verification
                </p>
                <div
                  className={cx(
                    globalStyles.flex,
                    globalStyles.alignItemsCenter,
                    styles.amountRadio,
                  )}
                >
                  <div className={styles.amountRadioItem}>
                    <Radio
                      changed={() => {
                        setData({ ...data, verify: true });
                      }}
                      id="1"
                      isSelected={data?.verify === true}
                      name="type"
                      testId="verify-radio"
                    >
                      Yes
                    </Radio>
                  </div>
                  <div className={styles.amountRadioItem}>
                    <Radio
                      changed={() => {
                        setData({
                          ...data,
                          verify: false,
                          verificationUrl: '',
                        });
                      }}
                      id="2"
                      isSelected={data?.verify === false}
                      name="type"
                    >
                      No
                    </Radio>
                  </div>
                  <ToolTip
                    id="create-product-token"
                    content="
                    This is to validate phone numbers when a customer tries to register for your product."
                  />{' '}
                  <p className={styles.callbackUrlInfo}>
                    What is a token verification?
                  </p>
                </div>
              </div>
              {data?.verify && (
                <div className={cx(styles.columnCreate, styles.inputLeft)}>
                  <Input
                    label="Token verification URL"
                    type="text"
                    placeholder="Enter URL here"
                    autoFocus
                    name="verificationUrl"
                    value={data?.verificationUrl}
                    onChange={handleChange}
                    ref={register({
                      required: 'Token verification URL is required',
                    })}
                    error={errors['verificationUrl']?.message}
                    data-testid="verify input"
                  />
                </div>
              )}
            </div>

            <div className={styles.rowCreate}>
              <div className={cx(styles.columnCreate, styles.inputLeft)}>
                <Input
                  label="Callback URL (Registration)"
                  type="text"
                  placeholder="Enter URL here"
                  autoFocus
                  name="registrationCallbackUrl"
                  value={data?.registrationCallbackUrl}
                  onChange={handleChange}
                  data-testid="registration callback"
                />
                {regCallback && (
                  <p
                    className={styles.authFormGroupError}
                    style={{ marginTop: '-10px', marginBottom: '20px' }}
                  >
                    <ErrorIcon />
                    Registration callback is required
                  </p>
                )}
              </div>
              <div
                className={cx(
                  styles.columnCreate,
                  styles.inputRight,
                  styles.createRow,
                )}
              >
                <ToolTip
                  id="create-product-callback"
                  content="This allows us to send you a notification containing all details captured while onboarding a customer directly into your system.  "
                />
                <p className={styles.callbackUrlInfo}>
                  What is a callback URL (registration)
                </p>
              </div>
            </div>

            <div className={styles.rowCreate}>
              <div className={cx(styles.columnCreate, styles.inputLeft)}>
                <Input
                  label="Callback URL (Payments)"
                  type="text"
                  placeholder="Enter URL here"
                  autoFocus
                  name="paymentCallbackUrl"
                  value={data?.paymentCallbackUrl}
                  onChange={handleChange}
                  data-testid="payment callback"
                />
              </div>
              <div
                className={cx(
                  styles.columnCreate,
                  styles.inputRight,
                  styles.createRow,
                )}
              >
                <ToolTip
                  id="create-product-callback-pay"
                  content="This allows us to send you a notification containing payment details captured directly to your system"
                />
                <p className={styles.callbackUrlInfo}>
                  What is a call back URL (payments)
                </p>
              </div>
            </div>
          </div>

          <div
            className={cx(styles.columnCreate, styles.rightCreate, styles.pad)}
          >
            <p className={styles.description}>
              Here is a preview of the product you are creating
            </p>
            <PhonePreview title={data?.title}>
              <div className={styles.preview1}>
                <div
                  className={cx(
                    styles.verticalgroup,
                    globalStyles.pb0,
                    globalStyles.pt0,
                  )}
                >
                  <PreviewImageDefault style={{ margin: '10px 0' }} />

                  <h3 className={styles.previewtitle}>{data?.title}</h3>
                  <p className={styles.previewcategory}>{data?.category}</p>
                  <p className={styles.previewdescription}>
                    {data?.description}
                  </p>
                </div>
                <div className={styles.verticalgroup}></div>
              </div>
            </PhonePreview>
          </div>
        </div>
      </div>
      {handleSuccessModal()}
    </div>
  );
};

export default StepConfigureForm;
